import React from "react";
import * as S from "./Styled";
import { LOGO_HOTAREA } from "../../constants/urls";
import CategoryIcon from "@mui/icons-material/Category";


const Category = ({ categorie, iconMap }) => {
    const urlImageStore = categorie.imageName 
        ? `${LOGO_HOTAREA}${categorie.imageName}` 
        : null;

    const IconComponent = iconMap?.[categorie.slug];

    return (
        <S.CategoryBox
        as="a"
        key={categorie.id}
        // href={`https://clubes.meucupom.com/cupom-desconto-${categorie.slug}`}
        onClick={(e) => {
            e.preventDefault();
            const urlSlug = `cupom-desconto-${categorie.slug}`;
            window.open(`/${urlSlug}`, "_blank"); 
        }}
        rel="noopener noreferrer"
        >
        {urlImageStore ? (
            <S.StoreImage src={urlImageStore} alt={categorie.name} />
        ) : IconComponent ? (
            <IconComponent sx={{ fontSize: 48, color: "inherit", width: 48 }} />
        ) : (
            <CategoryIcon sx={{ fontSize: 48, color: "inherit", width:  48 }} />
        )}
        {categorie.name}
        </S.CategoryBox>
    );
};

export default Category;
